export const urls = Object.freeze({
  CALENDAR_LINK: 'https://wellnesscalendar.rutgers.edu/events/month/',
  FILTER_LINK: ' https://wellnesscalendar.rutgers.edu/events/photo/',
  SEARCH_BASE_URL:
    'https://wellnesscalendar.rutgers.edu/events/photo/?tribe-bar-search=',
  CHECK_IN_IMAGE:
    'https://firebasestorage.googleapis.com/v0/b/test-my-rutgers.appspot.com/o/ScarletWell-checkin-road.jpg?alt=media&token=bab93571-8a54-4bbd-a379-6a449d43b1dd', // Replace with your actual placeholder image URL
  MAIN_BUTTON:
    'https://newbrunswick.rutgers.edu/scarletwell/wellness-resources',
})

export const uiTextContent = Object.freeze({
  CHECK_IN_BUTTON_TEXT: 'View 8 Dimensions of Wellness',
  CHECK_IN_TEXT: 'Which area would you like to work on?',
})
